declare global {
    interface NuxtApp {
        $roomImageUrl:(val: string ) => string,
        $formatDate: ( dateValue:string) => string,
        $formatTime: ( dateValue:string) => string,
        $formatPrice:(price:number|undefined|null,with_unit?:boolean ) => string
    }

}
export default defineNuxtPlugin((nuxtApp) => {
    return {
      provide: {
        roomImageUrl( roomImage: string | undefined):string{
            if(roomImage){
                const runtimeConfig  = useRuntimeConfig();
                return runtimeConfig.public.apiUrl +'/' + roomImage
            }
            return ""
        },
        formatDate( dateValue:string) {
            if (!dateValue) return ""
            return useNuxtApp().$dayjs(dateValue).format("YYYY/MM/DD (dd)")
        },
        formatTime( dateValue:string){
            return useNuxtApp().$dayjs(dateValue).format('HH:mm')
        },
        formatPrice(price:number|undefined|null,with_unit:boolean = true ){
            let price_string = ''
            if(price==undefined || price == null){
                price_string = '0'
            }else{
                price_string = price.toLocaleString()
            }
            return `${price_string} `+(with_unit ? '円(税込)':'')
        },

    }}})
